import { useEffect, useState } from "react";

function useOfflineHook() {
  const [offline, setOffline] = useState(false);

  useEffect(() => {
    const onlineHandler = () => {
      setOffline(false);
    };
    const offlineHandler = () => {
      setOffline(true);
    };

    window.addEventListener("online", onlineHandler);
    window.addEventListener("offline", offlineHandler);

    return () => {
      window.removeEventListener("offline", offlineHandler);
      window.removeEventListener("online", onlineHandler);
    };
  }, []);
  return offline;
}

export default useOfflineHook;
